import { render } from "./ElementoRestriccion.vue?vue&type=template&id=67ac2302&scoped=true"
import script from "./ElementoRestriccion.vue?vue&type=script&lang=js"
export * from "./ElementoRestriccion.vue?vue&type=script&lang=js"

import "./ElementoRestriccion.vue?vue&type=style&index=0&id=67ac2302&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ac2302"]])

export default __exports__